/* =========================================================
   INFINITE CAROUSEL (ARROWS ONLY) — WORKING VERSION
   - Smooth transition
   - Seamless loop using clones
   - No keyboard / drag / mouse slide
   ========================================================= */

( () => {
	// Get all the window-frame div in the document
	const windowFrames = document.querySelectorAll( '.window-frame' );
	if ( windowFrames.length === 0 ) return;

	windowFrames.forEach( ( windowFrame ) => {
		const carousel = windowFrame.querySelector( '.carousel' );
		if ( ! carousel ) return;

		// Get the track that contains all slides, if not on the page, stop safely
		const track = carousel.querySelector( '.carousel__track' );
		if ( ! track ) return;

		// Get arrow buttons, if not on the page, stop safely
		const prevBtn = windowFrame.querySelector( '.carousel__btn--prev' );
		const nextBtn = windowFrame.querySelector( '.carousel__btn--next' );
		if ( ! prevBtn || ! nextBtn ) return;

		// Get the current slides (BEFORE cloning)
		const realSlides = Array.from( track.children );
		// If there are no slides, stop safely
		if ( realSlides.length === 0 ) return;

		// Clone the first and last real slide (this goes at the end)
		const firstClone = realSlides[ 0 ].cloneNode( true );
		const lastClone = realSlides[ realSlides.length - 1 ].cloneNode( true );
		// Mark clones so we can recognize them if needed
		firstClone.dataset.clone = 'true';
		lastClone.dataset.clone = 'true';
		// Insert the last clone as the very first element in the track
		track.insertBefore( lastClone, realSlides[ 0 ] );
		// Append the first clone as the very last element in the track
		track.appendChild( firstClone );
		// Re-read slides (NOW includes clones)
		const slides = Array.from( track.children );

		// Start on the first REAL slide (index 1 because index 0 is lastClone)
		let index = 1;
		// Store current slide width (calculated later)
		let slideWidth = 0;
		// Prevent multiple clicks while animating
		let isAnimating = false;
		// Set the transition once (smooth movement)
		track.style.transition = 'transform 450ms ease';

		// A function to measure slide width and correctly position the track
		function updateSizesAndPosition() {
			// Measure the width of the first REAL slide (index 1)
			slideWidth = slides[ 1 ].getBoundingClientRect().width;
			// Temporarily disable transition (so resize / setup doesn't animate)
			track.style.transition = 'none';

			// Move the track to show the current index
			track.style.transform = `translateX(${ -index * slideWidth }px)`;
			// Force the browser to apply the transform immediately
			track.getBoundingClientRect();
			// Restore smooth transition for normal clicks
			track.style.transition = 'transform 450ms ease';
		}

		// Initial sizing + correct starting position
		updateSizesAndPosition();

		// NEXT button: move one slide to the right
		nextBtn.addEventListener( 'click', () => {
			// Ignore clicks during animation
			if ( isAnimating ) return;
			// Lock until the transition ends
			isAnimating = true;
			// Go to next slide
			index = index + 1;
			// Animate to that slide
			track.style.transform = `translateX(${ -index * slideWidth }px)`;
		} );

		// PREV button: move one slide to the left
		prevBtn.addEventListener( 'click', () => {
			// Ignore clicks during animation
			if ( isAnimating ) return;
			// Lock until the transition ends
			isAnimating = true;
			// Go to previous slide
			index = index - 1;
			// Animate to that slide
			track.style.transform = `translateX(${ -index * slideWidth }px)`;
		} );

		// When the sliding animation ends, "snap" if we landed on a clone
		track.addEventListener( 'transitionend', () => {
			// Unlock clicks now that the animation ended
			isAnimating = false;

			// If we are on the last element (firstClone), snap to first REAL slide
			if ( index === slides.length - 1 ) {
				// Disable transition for an instant snap
				track.style.transition = 'none';
				// Jump to first REAL slide
				index = 1;
				// Apply the snap
				track.style.transform = `translateX(${
					-index * slideWidth
				}px)`;
				// Force browser to commit the snap
				track.getBoundingClientRect();
				// Re-enable smooth transitions
				track.style.transition = 'transform 450ms ease';
			}

			// If we are on the first element (lastClone), snap to last REAL slide
			if ( index === 0 ) {
				// Disable transition for an instant snap
				track.style.transition = 'none';
				// Jump to last REAL slide (second-to-last element)
				index = slides.length - 2;
				// Apply the snap
				track.style.transform = `translateX(${
					-index * slideWidth
				}px)`;
				// Force browser to commit the snap
				track.getBoundingClientRect();
				// Re-enable smooth transitions
				track.style.transition = 'transform 450ms ease';
			}
		} );

		// On resize, re-measure slide width and keep the same slide centered
		window.addEventListener( 'resize', () => {
			// Recalculate widths and reposition without animation
			updateSizesAndPosition();
		} );
	} );
} )();